import React from "react";
import styles from "./FinUpdateCompleted.module.scss";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";

function FinUpdationCompleted() {
  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>Thanks For Submitting Document!</p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                Your documents have been uploaded. Check your registered email
                for a confirmation message. For any questions, contact our
                support team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinUpdationCompleted;
